<div *ngIf="isOffline$ | async" class="connectivity-banner" role="status" aria-live="polite">
  <mat-icon class="connectivity-banner__icon" aria-hidden="true">cloud_off</mat-icon>
  <span class="connectivity-banner__text"> You appear to be offline. We'll keep trying to reconnect. </span>
</div>
